package com.flowyride.data.routing.internal

import com.flowyride.core.api.ApiErrorDto
import com.flowyride.core.api.toRoutingException
import com.flowyride.core.domain.routing.RoutingException
import com.flowyride.core.network.NetworkJson
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText

/** The FlowyRide server's error body as a [RoutingException]; any other page (proxy error…) means unavailable. */
internal suspend fun HttpResponse.toServerRoutingException(maxWaypoints: Int): RoutingException {
    val error = runCatching { NetworkJson.decodeFromString<ApiErrorDto>(bodyAsText()) }.getOrNull()
    return error?.toRoutingException(maxWaypoints)
        ?: RoutingException.EngineUnavailable("FlowyRide server (HTTP ${status.value})")
}
